import { TableSorting } from "@/components/elements/Table";
import { TProductAccessSortKey } from "@/features/customer-user/hooks/useSortedProductAccess";
import { text } from "@/theme/colors";
import { Typography } from "@mui/material";

export const productAccessSortableHeader = (name: TProductAccessSortKey, label: string) => () => (
  <TableSorting name={name}>
    <Typography variant="body14Bold" color={text.primary}>
      {label}
    </Typography>
  </TableSorting>
);
